import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const wrapper = css`
  counter-reset: idx;
  margin-top: 20px;
`;

export const itemWrapper = css`
  display: flex;
  flex-direction: row;
`;

export const itemContainer = css`
  display: flex;
  margin-bottom: 8px;
  width: 100%;
`;

export const itemInput = css`
  display: flex;
  flex-direction: column;

  > #item {
    margin: 0 0 10px 26px;
  }

  > #meta {
    margin-bottom: 10px;
  }

  :not(:first-child) {
    margin-left: 10px;
  }

  :nth-child(1) {
    width: 50%;
  }
  :nth-child(2) {
    width: 20%;
  }
  :nth-child(3) {
    width: 30%;
  }
`;

export const counterIndex = css`
  display: flex;

  :before {
    counter-increment: idx;
    content: counter(idx);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-right: 10px;
    min-width: 16px;
  }
`;

export const itemSelect = css`
  width: 100%;
`;

export const observation = css`
  flex: 1;
`;

export const deleteButton = css`
  cursor: pointer;
  margin: auto 0 auto 10px;
  color: ${colors.gray.default};

  :hover {
    color: ${colors.gray.dark};
  }

  && {
    font-size: ${fonts.size.larger};
  }
`;
